export function washData_bannerItem(walkedNode){


  for(var languageId in walkedNode.translateRes){
    if(!walkedNode.translateRes[languageId].imgAttr){
      walkedNode.translateRes[languageId].imgAttr = {
        alt: walkedNode.translateRes[languageId].alt,
        title: walkedNode.translateRes[languageId].title
      }

      delete walkedNode.translateRes[languageId].alt
      delete walkedNode.translateRes[languageId].title
    }
  }

}
